import { Component, AfterViewInit, AfterContentInit } from '@angular/core';
import { SectionFormDirective } from '@app/classes/section-form.class';
import { FormBuilder } from '@angular/forms';
import { ModalService } from '@app/services/modal/modal.service';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { equals, or } from 'ramda'
import { ApplicationService } from '@app/services/application/application.service';
import { otherMedicalQuestion } from '../../other/other-benefits/other-benefits-labels'
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ServiceConfigService } from '@app/services/service-config.service';
import { personReceivingMedical } from '@app/helpers/models.helpers'

const vehicleInfo = ({ assetType, vehicleYear, vehicleMake, vehicleModel }) => {
  const result = []
  if(or(vehicleYear, vehicleMake)){
    result[0] = `${assetType.value} - ${vehicleYear || ''} ${vehicleMake || ''} ${vehicleModel || ''}`;
    result[1] = `${assetType.spValue} - ${vehicleYear || ''} ${vehicleMake || ''} ${vehicleModel || ''}`;
  }else {
    result[0] = `${assetType.value}`
    result[1] = `${assetType.spValue}`;
  }
  return result;
}

@Component({
    templateUrl: './summary-presumptive.component.html',
    standalone: false
})

export class SummaryPresumptiveComponent extends SectionFormDirective implements AfterContentInit, AfterViewInit {
  isPresumptive = false;
  appType: string;
  isPresumptiveBccApp = false;
  showTaxSummary = true;
  showRelationships = true;
  showOtherHealthInsurance = true;
  results = [];
  updateToNonQualifiedCitizenshipSwitch = false;
  currentDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
  assetIndSw = false;
  transferredResIndSw = false;
  expensesIndSw = false;

  individualSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Date of Birth', prop: 'birthDate' }, { name: 'Gender', prop: 'gender' }, { name: 'U.S. Citizen', prop: 'citizen' }, { name: 'Immigration Status', prop: 'immgStatus' }, { name: 'TN Resident', prop: 'tennesseeResident' }];
  individualSummaryResults: any;

  relationshipSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Relationship', prop: 'relationship' }, { name: 'Caretaker', prop: 'primaryCaregiver' }];
  relationshipSummaryResults: any;

  otherHealthInsuranceSummaryColumns = [{ name: 'Policy Holder', prop: 'policyHolder' }, { name: 'Who is Covered', prop: 'coveredMembers' }, { name: 'Insurance Company/Policy Number', prop: 'insuranceCompanyNameOrPolicyNumber' }, { name: 'Monthly Premium', prop: 'monthlyPremium' }];
  otherHealthInsuranceSummaryResults: any;

  taxInformationSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Joint Filing with Spouse', prop: 'jointFilingWithSpouse' }, { name: 'Tax Dependents <br>Inside Household', prop: 'taxDependentsInsideHousehold' }, { name: 'Tax Dependents <br>Outside Household', prop: 'taxDependentsOutsideHousehold'}];
  taxInformationSummaryResults: any;

  earnedIncomeSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Frequency', prop: 'frequency' },{ name: 'Employer Name', prop: 'name' }, { name: 'Amount', prop: 'amount' }]
  earnedIncomeSummaryResults: any;

  selfEmploymentIncomeSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Type', prop: 'type' },{ name: 'Business Name', prop: 'businessName' }, { name: 'Monthly Amount', prop: 'monthlyNetAmount' }]
  selfEmploymentIncomeSummaryResults: any;

  otherIncomeSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Type', prop: 'type' }, { name: 'Frequency', prop: 'frequency' }, { name: 'Amount', prop: 'amount' }]
  otherIncomeSummaryResults: any;

  taxDeductionsSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Type', prop: 'type' }, { name: 'Monthly Amount', prop: 'deductionAmount' }]
  taxDeductionsSummaryResults: any;

  otherQuestionsSummaryColumns = [{ name: 'Person Name', prop: 'personName' }, { name: 'Assistance Type', prop: 'assistanceType' }]
  otherQuestionsSummaryResults = [];

  transferredResourcesSummaryColumns = [{ name: 'Original Owner', prop: 'personName' }, { name: 'Type', prop: 'typeOfAsset.value' }, { name: 'Value', prop: 'valueOfAsset'}, { name: 'Amount Received', prop: 'inReturnAmount'}, { name: 'Transfer Date', prop: 'assetTransferDate'}];
  transferredResourcesSummaryResults: any;


  shelterOrUtilityExpenseSummaryColumns = [{ name: 'Name', prop: 'personName' },{ name: 'Expense Type', prop: 'housingTypeExpense' }, { name: 'How Much', prop: 'expenseAmount'},{ name: 'How Often', prop: 'expenseFrequencyCode.value' }];
  shelterOrUtilityExpenseSummaryResults: any;

  dependentCareSummaryColumns = [{ name: 'Name', prop: 'personName' },{ name: 'Person Receiving Care', prop: 'personReceivingCare'}, { name: 'How Much', prop: 'expenseAmount' }, { name: 'How Often', prop: 'expenseFrequencyCode.value' }];
  dependentCareSummaryResults: any;

  mandatoryPaymentsSummaryColumns = [{ name: 'Name', prop: 'personName' }, { name: 'Expense Type', prop: 'supportKindCode' }, { name: 'How Much', prop: 'expenseAmount' }];
  mandatoryPaymentsSummaryResults: any;

  medicalBillsSummaryColumns = [{ name: 'Name', prop: 'personName' },{ name: 'Person Who Received Care', args: personReceivingMedical, pipe: 'domain', grow: 7},{ name: 'Medical Bill Type', prop: 'medicalBillType.value' },{ name: 'Total Amount', prop: 'medicalBillUnpaidAmt', pipe: 'currency' },{ name: 'Amount you have already paid', prop: 'medicalBillOweAmt', pipe: 'currency' }];
  medicalBillsSummaryResults: any;

  accessToOtherCoverageSummaryColumns = [{ name: 'Name', prop: 'personName' }, { name: 'Contact Name', prop: 'data.insuranceCompanyName' }, { name: 'Minimum Requirement Met?', prop: 'data.minRequirementMetSw.value'}];
  accessToOtherCoverageSummaryResults: any;

  financialResourcesSummaryColumns = [{ name: 'Owner', prop: 'personName' }, { name: 'Type', prop: 'assetType.value' }, { name: 'Total Value', prop: 'assetAmount'}];
  financialResourcesSummaryResults: any;
  
  vehicleSummaryColumns = [{ name: 'Owner', prop: 'personName' }, {name: 'Vehicle', prop: 'data', pipe: 'domain', args: vehicleInfo}, { name: 'Total Value', prop: 'assetAmount'}, { name: 'Amount Owed', prop: 'owedAmount'}];
  vehicleSummaryResults: any;

  propertySummaryColumns = [ { name: 'Owner', prop: 'personName' }, { name: 'Property Type', prop: 'assetType.value' }, { name: 'Amount Owed', prop: 'owedAmount'}, { name: 'Property Value', prop: 'assetAmount' }];
  propertySummaryResults: any;

  burialResourcesSummaryColumns = [{ name: 'Owner', prop: 'personName' }, { name: 'Burial Type', prop: 'assetType.value' }, { name: 'Total Value', prop: 'assetAmount'}];
  burialResourcesSummaryResults: any;

  lifeInsuranceSummaryColumns = [{ name: 'Owner', prop: 'personName' }, { name: 'Policy Type', prop: 'assetType.value' }, { name: 'Face Value', prop: 'faceAmount'}, { name: 'Insurance Company/ Policy Number', prop: 'insuranceCompOrPolicyNumber' }];
  lifeInsuranceSummaryResults: any;

  otherResourcesSummaryColumns = [ { name: 'Owner', prop: 'personName' }, { name: 'Type', prop: 'assetType.value' }, { name: 'Value', prop: 'assetAmount'}, { name: 'Amount Owed', prop: 'owedAmount'}];
  otherResourcesSummaryResults: any;

  constructor(builder: FormBuilder,
    private modalService: ModalService,
    private router: Router,
    private datePipe: DatePipe,
    private appService: ApplicationService,
    private titleService: Title,
    private serverConfig: ServiceConfigService) {
    super(builder)
    this.titleService.setTitle('Application Summary');
  }

  ngAfterContentInit() { }

  ngAfterViewInit() {
    const nonFfpEffDate = this.serverConfig.getServerConfig().nonFfpEffDate;
    if (nonFfpEffDate && new Date(this.currentDate) >= new Date(nonFfpEffDate)) {
      this.updateToNonQualifiedCitizenshipSwitch = true;
    }
    this.appType = sessionStorage.getItem('appType');
    this.isPresumptiveBccApp = this.appType === 'BCC'; 
    this.isPresumptive = this.appType === 'HPE' || this.appType === 'PRG' || this.appType === 'BCC';
    this.record.data.otherQuestionSummary?.otherBenefitsIndvProfileData?.map((item) => {
      if (item?.assetIndSw?.code === 'Y') {
        this.assetIndSw = true;
      }
      if (item?.transferredResIndSw?.code === 'Y') {
        this.transferredResIndSw = true;
      }
      if (item?.expensesIndSw?.code === 'Y') {
        this.expensesIndSw = true;
      }
    });

    this.individualSummaryResults = this.individuals.map(({ name, gender, age, tennesseeResident, headOfHousehold, identifier }) => {
      const individualData = this.record.data.individualSummary.filter((x => x.individualId == identifier))[0];
      const immgStatus = (individualData.immigrationStatus) ? individualData.immigrationStatus.value : 'N/A';
      const currentImmigrationStatus = (individualData.currImmigrationStatus) ? individualData.currImmigrationStatus.value : 'N/A';
      const birthDate = this.datePipe.transform(individualData.dob, "MM/dd/yyyy");

      return {
        personName: `${name.fullName} ${age} ${gender.code}`,
        gender: gender.value,
        birthDate: birthDate,
        citizen: individualData?.usCitizen?.value,
        tennesseeResident: tennesseeResident?.value,
        immgStatus: (() => {
          if (this.updateToNonQualifiedCitizenshipSwitch) {
            const currentStatus = currentImmigrationStatus;
            const alienStatus = individualData.immigrationStatus?.value;
            if (currentStatus && alienStatus) {
              return `${currentStatus}, ${alienStatus}`;
            } else if (currentStatus) {
              return currentStatus;
            } else if (alienStatus) {
              return alienStatus;
            }
            return '';
          } else {
            return immgStatus;
          }
        })(),
        data: {
          headOfHousehold: headOfHousehold
        },
        identifier
      }
      window.scroll(0,0);
    });

    this.earnedIncomeSummaryResults = this.record.data.earnedIncomeSummary.map(({ individualId, frequency, grossAmount,employer, recordId }) => {
      const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
      let isInteger = false;
      if (grossAmount) {
        isInteger = Number.isInteger(grossAmount)
        grossAmount = isInteger ? grossAmount.toLocaleString() + '.00' : this.decimalFormat(grossAmount.toLocaleString());
      }
      return {
        personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
        frequency: frequency.value,
        amount: ((grossAmount != null) ? ('$' + grossAmount)  : grossAmount ),
        individualId,
        name: employer?.name || 'Not Answered',
        recordId
      }
    });

    this.otherIncomeSummaryResults = this.record.data.otherIncomeSummary.map(({ individualId, type, frequency, grossAmount, recordId }) => {
      const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
      let isInteger = false;
      if (grossAmount) {
        isInteger = Number.isInteger(grossAmount)
        grossAmount = isInteger ? grossAmount.toLocaleString() + '.00' : this.decimalFormat(grossAmount.toLocaleString());
      }
      return {
        personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
        type: type.value,
        frequency: frequency.value,
        amount: ((grossAmount != null) ? ('$' +grossAmount)  : grossAmount ),
        recordId,
        individualId
      }
    });

    this.selfEmploymentIncomeSummaryResults = this.record.data.selfEmploymentSummary.map(({ individualId, type, monthlyNetAmount,businessName, recordId }) => {
      const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
      let isInteger = false;
      if (monthlyNetAmount) {
        isInteger = Number.isInteger(monthlyNetAmount)
        monthlyNetAmount = isInteger ? monthlyNetAmount.toLocaleString() + '.00' : this.decimalFormat(monthlyNetAmount.toLocaleString());
      }
      return {
        personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
        type: type.value,
        monthlyNetAmount: ((monthlyNetAmount != null) ? ('$' +monthlyNetAmount)  : monthlyNetAmount ),
        recordId,
        businessName: businessName || 'Not Answered',
        individualId
      }
    });

    this.taxDeductionsSummaryResults = this.record.data.taxDeductionsSummary.map(({ indvId, deductionType, deductionAmount, taxDedSeqNum }) => {
      const personFulldetails = this.individuals.filter((x => x.identifier == indvId))[0];
      let isInteger = false;
      if (deductionAmount) {
        isInteger = Number.isInteger(deductionAmount)
        deductionAmount = isInteger ? deductionAmount.toLocaleString() + '.00' : this.decimalFormat(deductionAmount.toLocaleString());
      }
      return {
        personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
        type: deductionType?.value,
        deductionAmount: ((deductionAmount != null) ? ('$' + deductionAmount)  : deductionAmount ),
        indvId,
        taxDedSeqNum: taxDedSeqNum
      }
    });

    this.relationshipSummaryResults = this.record.data.relationShipSummary == null ? this.showRelationships = false : this.record.data.relationShipSummary?.relationshipList?.map(({ sourceIndividual, referenceIndividual, relation, primaryCaregiver }) => {
      const sourcePersonFulldetails = this.members.filter((x => x.identifier == sourceIndividual))[0];
      const refSourcePersonFulldetails = this.members.filter((x => x.identifier == referenceIndividual))[0];
      return {
        personName: `${sourcePersonFulldetails?.name.fullName} ${sourcePersonFulldetails?.age} ${sourcePersonFulldetails?.gender.code}`,
        relationship: `${relation.value} ${refSourcePersonFulldetails?.name?.fullName}`,
        primaryCaregiver: primaryCaregiver?.value,
        recordOwner: sourceIndividual.toString(),
        data: {
          headOfHousehold: true
        },
      }
    });

    this.otherQuestionsSummaryResults = this.record.data.otherQuestionSummary?.otherBenefitsIndvProfileData?.map((item) => {
      const personFulldetails = this.individuals.filter((x => x.identifier == item.indvId))[0];
      let benefitsEnrolled = '';      
      Object.keys(item).forEach((x) => {
        if (otherMedicalQuestion[x] && item[x] && item[x].code === 'Y'){
          benefitsEnrolled = benefitsEnrolled + otherMedicalQuestion[x] + '<br/>'
        }
      })
      if (benefitsEnrolled === '') {
        return '';
      }
      return {
        personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
        assistanceType: benefitsEnrolled,
        identifier: item.indvId,
        data: {
          headOfHousehold: true
        },
      }
    });

    this.otherQuestionsSummaryResults = this.otherQuestionsSummaryResults.filter(Boolean)

    this.otherHealthInsuranceSummaryResults = this.record.data.otherHealthInsuranceSummary == null ? this.showOtherHealthInsurance = false : this.record.data.otherHealthInsuranceSummary?.map(({ policyHolder, insuranceCompanyName, policyNumber, monthlyPremiumAmountForKB, coveredIndividualDetails, recordId}) => {
      const policyHolderDetails = this.individuals.filter((x => x.identifier == policyHolder.houseMember))[0];
      let coveredMembers = '';
      coveredIndividualDetails?.converedIndiv?.forEach((item) => {
        const coveredPerson = this.individuals.filter((x => x.identifier == item.coveredIndividualNumber))[0];
        if (coveredPerson) {
          coveredMembers = coveredMembers + coveredPerson.name.fullName + '<br/>';
        }
      });
      if (coveredMembers === '') {
        coveredMembers = 'Not Answered';
      }
      let isInteger = false;
      if (monthlyPremiumAmountForKB) {
        isInteger = Number.isInteger(monthlyPremiumAmountForKB);
        monthlyPremiumAmountForKB = isInteger ? monthlyPremiumAmountForKB.toLocaleString() + '.00' : this.decimalFormat(monthlyPremiumAmountForKB.toLocaleString());
      }
      let policyHolderName = `${policyHolderDetails?.name.fullName} ${policyHolderDetails?.age} ${policyHolderDetails?.gender.code}`
      if (policyHolderDetails === undefined || policyHolder.houseMember === 0) {
        policyHolderName = policyHolder.policyHolderFirstName + ' ' + policyHolder.policyHolderLastName;
      }
      return {
        policyHolder: policyHolderName,
        coveredMembers: coveredMembers,
        insuranceCompanyNameOrPolicyNumber: `${insuranceCompanyName || 'Not Answered'} / ${policyNumber || 'Not Answered'}`,
        monthlyPremium: monthlyPremiumAmountForKB != null ? ('$' + monthlyPremiumAmountForKB) : 'Not Answered',
        recordOwner: policyHolder.houseMember,
        recordId,
        data: {
          headOfHousehold: false
        },
      }
    });
      
    if (this.record.data.taxFilingSummary != null) {
      this.taxInformationSummaryResults = this.record.data.taxFilingSummary?.map(({ taxFilingIndividualId, jointFilerSw, dependentOutsideHousehold, dependentIndvNumbers, jointFilerOutsideHousehold }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == taxFilingIndividualId))[0];
        let taxdependentInside = ""
        dependentIndvNumbers?.forEach((item) => {
          taxdependentInside = taxdependentInside + this.individuals.filter((x => x.identifier == item.individualId))[0]?.name.fullName + '<br/>';
        });
        const jointFiler = jointFilerSw ? jointFilerSw.value : jointFilerOutsideHousehold ? jointFilerOutsideHousehold : 'N/A';
        const dependentOutside = dependentOutsideHousehold ? dependentOutsideHousehold : 'N/A';
        if (taxdependentInside == '') {
          taxdependentInside = 'N/A'
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          jointFilingWithSpouse: jointFiler,
          taxDependentsInsideHousehold : taxdependentInside,
          taxDependentsOutsideHousehold : dependentOutside,
          recordOwner: taxFilingIndividualId
        }
      }); 
    } else {
      this.showTaxSummary = false;
    }

    if(this.record.data.shelterUtilitySummary != null) {
      this.shelterOrUtilityExpenseSummaryResults = this.record.data.shelterUtilitySummary.map(({ housingTypeExpense, expensePaymentInformation, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let expenseAmount = expensePaymentInformation?.expenseAmount;
        let isInteger = false;
        if (expenseAmount) {
          isInteger = Number.isInteger(expenseAmount);
          expenseAmount = isInteger ? expenseAmount.toLocaleString() + '.00' : this.decimalFormat(expenseAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,         
          housingTypeExpense: housingTypeExpense.value,            
          expenseAmount: expenseAmount != null ? ('$' + expenseAmount) : 'Not Answered',
          expenseFrequencyCode: expensePaymentInformation?.expenseFrequencyCode,            
          recordId,
          individualId,
          data: {
            headOfHousehold: false
          },
        };
      });
    }

    if(this.record.data.dependentCareSummary != null) {
      this.dependentCareSummaryResults = this.record.data.dependentCareSummary.map(({ dependantCareInformation, expensePaymentInformation, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        const receivingCareIndividual = this.individuals.filter((x => x.identifier == dependantCareInformation?.dependantIndivNumber))[0];
        let personReceivingCare = '';
        if (receivingCareIndividual) {
          personReceivingCare = `${receivingCareIndividual.name.fullName} ${receivingCareIndividual.age} ${receivingCareIndividual.gender.code}`;
        } else if (dependantCareInformation?.personOutOfHouseholdName) {
          personReceivingCare = dependantCareInformation.personOutOfHouseholdName;
        } else {
          personReceivingCare = 'Not Answered';
        }
        let expenseAmount = expensePaymentInformation?.expenseAmount;
        let isInteger = false;
        if (expenseAmount) {
          isInteger = Number.isInteger(expenseAmount);
          expenseAmount = isInteger ? expenseAmount.toLocaleString() + '.00' : this.decimalFormat(expenseAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          personReceivingCare: personReceivingCare,
          identifier: individualId,          
          expenseAmount: expenseAmount != null ? ('$' + expenseAmount) : 'Not Answered',
          expenseFrequencyCode: expensePaymentInformation?.expenseFrequencyCode,
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.supportPaymentsSummary != null) {
      this.mandatoryPaymentsSummaryResults = this.record.data.supportPaymentsSummary.map(({ supportKindCode, expenseAmount, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedExpenseAmount = expenseAmount;
        let isInteger = false;
        if (formattedExpenseAmount) {
          isInteger = Number.isInteger(formattedExpenseAmount);
          formattedExpenseAmount = isInteger ? formattedExpenseAmount.toLocaleString() + '.00' : this.decimalFormat(formattedExpenseAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,          
          supportKindCode: supportKindCode.value,
          expenseAmount: formattedExpenseAmount != null ? ('$' + formattedExpenseAmount) : 'Not Answered',
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.medicareSummary != null) {
      this.medicalBillsSummaryResults = this.record.data.medicareSummary.map(({ medicalBillType, medicalBillOweAmt, medicalBillUnpaidAmt, careReceivingIndvNumber, personOutOfHouseholdName, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
       
        let formattedOweAmt = medicalBillOweAmt;
        let formattedUnpaidAmt = medicalBillUnpaidAmt;
        let isInteger = false;
        if (formattedOweAmt) {
          isInteger = Number.isInteger(formattedOweAmt);
          formattedOweAmt = isInteger ? formattedOweAmt.toLocaleString() + '.00' : this.decimalFormat(formattedOweAmt.toLocaleString());
        }
        if (formattedUnpaidAmt) {
          isInteger = Number.isInteger(formattedUnpaidAmt);
          formattedUnpaidAmt = isInteger ? formattedUnpaidAmt.toLocaleString() + '.00' : this.decimalFormat(formattedUnpaidAmt.toLocaleString());
        }
        
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          data: {
            careReceivingIndvNumber: careReceivingIndvNumber,
            personOutOfHouseholdName: personOutOfHouseholdName
          },
          medicalBillType: medicalBillType,
          medicalBillOweAmt: formattedOweAmt,
          medicalBillUnpaidAmt: formattedUnpaidAmt,          
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.otherCoverageSummary != null) {
      this.accessToOtherCoverageSummaryResults = this.record.data.otherCoverageSummary.map(({ insuranceCompanyName, minRequirementMetSw, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          data: {
            insuranceCompanyName: insuranceCompanyName || 'Not Answered',
            minRequirementMetSw: minRequirementMetSw
          },
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.liquidResourceSummary != null) {
      this.financialResourcesSummaryResults = this.record.data.liquidResourceSummary.map(({ assetType, assetAmount, accountInformation, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedAssetAmount = assetAmount;
        let isInteger = false;
        if (formattedAssetAmount) {
          isInteger = Number.isInteger(formattedAssetAmount);
          formattedAssetAmount = isInteger ? formattedAssetAmount.toLocaleString() + '.00' : this.decimalFormat(formattedAssetAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          assetType: assetType,
          bankName: accountInformation?.bankSearch?.bankName || 'Not Answered',
          assetAmount: formattedAssetAmount != null ? ('$' + formattedAssetAmount) : 'Not Answered',
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.vehicleResourceSummary != null) {
      this.vehicleSummaryResults = this.record.data.vehicleResourceSummary.map(({ assetType, assetAmount, owedAmount, vehicleYear, vehicleMake, vehicleModel, vehicleUsage, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedAssetAmount = assetAmount;
        let formattedOwedAmount = owedAmount;
        let isInteger = false;
        if (formattedAssetAmount) {
          isInteger = Number.isInteger(formattedAssetAmount);
          formattedAssetAmount = isInteger ? formattedAssetAmount.toLocaleString() + '.00' : this.decimalFormat(formattedAssetAmount.toLocaleString());
        }
        if (formattedOwedAmount) {
          isInteger = Number.isInteger(formattedOwedAmount);
          formattedOwedAmount = isInteger ? formattedOwedAmount.toLocaleString() + '.00' : this.decimalFormat(formattedOwedAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          data: {
            assetType: assetType,
            vehicleYear: vehicleYear,
            vehicleMake: vehicleMake,
            vehicleModel: vehicleModel,
            vehicleUsage: vehicleUsage
          },
          assetAmount: formattedAssetAmount != null ? ('$' + formattedAssetAmount) : 'Not Answered',
          owedAmount: formattedOwedAmount != null ? ('$' + formattedOwedAmount) : 'Not Answered',
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.realEstateResourceSummary != null) {
      this.propertySummaryResults = this.record.data.realEstateResourceSummary.map(({ assetType, assetAmount, owedAmount, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedAssetAmount = assetAmount;
        let formattedOwedAmount = owedAmount;
        let isInteger = false;
        if (formattedAssetAmount) {
          isInteger = Number.isInteger(formattedAssetAmount);
          formattedAssetAmount = isInteger ? formattedAssetAmount.toLocaleString() + '.00' : this.decimalFormat(formattedAssetAmount.toLocaleString());
        }
        if (formattedOwedAmount) {
          isInteger = Number.isInteger(formattedOwedAmount);
          formattedOwedAmount = isInteger ? formattedOwedAmount.toLocaleString() + '.00' : this.decimalFormat(formattedOwedAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          assetType: assetType,
          assetAmount: formattedAssetAmount != null ? ('$' + formattedAssetAmount) : 'Not Answered',
          owedAmount: formattedOwedAmount != null ? ('$' + formattedOwedAmount) : 'Not Answered',
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.burialResourceSummary != null) {
      this.burialResourcesSummaryResults = this.record.data.burialResourceSummary.map(({ assetType, assetAmount, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedAssetAmount = assetAmount;
        let isInteger = false;
        if (formattedAssetAmount) {
          isInteger = Number.isInteger(formattedAssetAmount);
          formattedAssetAmount = isInteger ? formattedAssetAmount.toLocaleString() + '.00' : this.decimalFormat(formattedAssetAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          assetType: assetType,
          assetAmount: formattedAssetAmount != null ? ('$' + formattedAssetAmount) : 'Not Answered',
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.lifeInsuranceResourceSummary != null) {
      this.lifeInsuranceSummaryResults = this.record.data.lifeInsuranceResourceSummary.map(({ assetType, faceAmount, insuranceName, policyNumber, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedFaceAmount = faceAmount;
        let isInteger = false;
        if (formattedFaceAmount) {
          isInteger = Number.isInteger(formattedFaceAmount);
          formattedFaceAmount = isInteger ? formattedFaceAmount.toLocaleString() + '.00' : this.decimalFormat(formattedFaceAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          assetType: assetType,
          faceAmount: formattedFaceAmount != null ? ('$' + formattedFaceAmount) : 'Not Answered',
          insuranceCompOrPolicyNumber: `${insuranceName || 'Not Answered'} / ${policyNumber || 'Not Answered'}`,
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.otherResourceSummary != null) {
      this.otherResourcesSummaryResults = this.record.data.otherResourceSummary.map(({ assetType, assetAmount, owedAmount, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedAssetAmount = assetAmount;
        let formattedOwedAmount = owedAmount;
        let isInteger = false;
        if (formattedAssetAmount) {
          isInteger = Number.isInteger(formattedAssetAmount);
          formattedAssetAmount = isInteger ? formattedAssetAmount.toLocaleString() + '.00' : this.decimalFormat(formattedAssetAmount.toLocaleString());
        }
        if (formattedOwedAmount) {
          isInteger = Number.isInteger(formattedOwedAmount);
          formattedOwedAmount = isInteger ? formattedOwedAmount.toLocaleString() + '.00' : this.decimalFormat(formattedOwedAmount.toLocaleString());
        }
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          assetType: assetType,
          assetAmount: formattedAssetAmount != null ? ('$' + formattedAssetAmount) : 'Not Answered',
          owedAmount: formattedOwedAmount != null ? ('$' + formattedOwedAmount) : 'Not Answered',
          recordId,
          individualId
        };
      });
    }

    if(this.record.data.transferSummary != null) {
      this.transferredResourcesSummaryResults = this.record.data.transferSummary.map(({ typeOfAsset, valueOfAsset, inReturnAmount, assetTransferDate, recordId, individualId }) => {
        const personFulldetails = this.individuals.filter((x => x.identifier == individualId))[0];
        let formattedValueOfAsset = valueOfAsset;
        let formattedInReturnAmount = inReturnAmount;
        let isInteger = false;
        if (formattedValueOfAsset) {
          isInteger = Number.isInteger(formattedValueOfAsset);
          formattedValueOfAsset = isInteger ? formattedValueOfAsset.toLocaleString() + '.00' : this.decimalFormat(formattedValueOfAsset.toLocaleString());
        }
        if (formattedInReturnAmount) {
          isInteger = Number.isInteger(formattedInReturnAmount);
          formattedInReturnAmount = isInteger ? formattedInReturnAmount.toLocaleString() + '.00' : this.decimalFormat(formattedInReturnAmount.toLocaleString());
        }
        const formattedTransferDate = this.datePipe.transform(assetTransferDate, "MM/dd/yyyy");
        return {
          personName: `${personFulldetails?.name.fullName} ${personFulldetails?.age} ${personFulldetails?.gender.code}`,
          identifier: individualId,
          typeOfAsset: typeOfAsset,
          valueOfAsset: formattedValueOfAsset != null ? ('$' + formattedValueOfAsset) : 'Not Answered',
          inReturnAmount: formattedInReturnAmount != null ? ('$' + formattedInReturnAmount) : 'Not Answered',
          assetTransferDate: formattedTransferDate || 'Not Answered',
          recordId,
          individualId
        };
      });
    }

  }  

  decimalFormat(decimalNumber) {
    if (String(decimalNumber).split(".")[1]?.length === 1) {
      return decimalNumber + '0';
    } else {
      return decimalNumber
    }
  }

  onIndividualRowEdit(event: any) {
    if (event.headOfHousehold) {
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRAPL');
    } else {
      sessionStorage.setItem('selectedIndv', event.identifier);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/HHIND');
    }
  }

  onIndividualRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.individualSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.individualSummaryResults.filter(row => row.identifier != event.record.identifier);
            this.appService.removeRecord(sessionStorage.getItem('appNum'), {'individualId': event.record.identifier, 'sectionId': 'HHIND'}).subscribe(() => {
              this.individualSummaryResults.splice(index, 1);
              this.individualSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  addIndividual() {
    sessionStorage.setItem('addPerson', 'true');
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/HHIND');
  }

  onRelationshipsRowEdit() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRRLS');
  }
  onOtherHealthInsuranceRowEdit(event: any){
     sessionStorage.setItem('recordId', event.recordId);
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRHLC');
  }

  taxInformationRowEdit() {
    //Navigate to HHIND when we have only one indiv
    if(this.taxInformationSummaryResults?.length === 1){
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/HHIND');
    } else {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRRLS');
    }
  }

  taxInformationRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.taxInformationSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.taxInformationSummaryResults.filter(row => row.recordOwner != event.record.recordOwner);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), {'individualId': event.record.recordOwner.toString() + '-taxfiling', 'sectionId': 'PRASM'}, this.frameRequestData('taxFilingSummary', event.record.recordOwner)).subscribe(() => {
              this.taxInformationSummaryResults.splice(index, 1);
              this.taxInformationSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  earnedIncomeRowEdit() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRIND');
  }
  onTransferredResourcesRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/ASCLD');
    }
  }
  shelterOrUtilityExpenseRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/XPUTL');
    }
  }
  onAccessToOtherCoverageRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/XPOTH');
    }
  }
  onMandatoryPaymentsRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/XPSUP');
    }
  }
  onMedicalBillsRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/INMED');
    }
  }
  dependentCareRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/XPDEP');
    }
  }
  onFinancialResourcesRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/ASLIQ');
    }
  } 
  onVehicleRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/ASVEH');
    }
  }
  onPropertyRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/ASPRP');
    }
  }
  onBurialResourcesRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/ASBUR');
    }
  }
  onLifeInsuranceRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/ASLIF');
    }
  }
  onOtherResourcesRowEdit(event: any) {
    if (event?.recordId) {
      sessionStorage.setItem('recordId', event.recordId);
      this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/OTHRS');
    }
  }

  earnedIncomeRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.earnedIncomeSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.earnedIncomeSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), {'individualId': event.record.individualId + "-" + event.record.recordId, 'sectionId': 'PRASM'}, this.frameRequestData('earnedIncomeSummary', event.record.recordId)).subscribe(() => {
              this.earnedIncomeSummaryResults.splice(index, 1);
              this.earnedIncomeSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  onOtherHealthInsuranceRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.otherHealthInsuranceSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
           const remainingRows = this.otherHealthInsuranceSummaryResults.filter(row => row.recordId != event.record.recordId);            
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), {'individualId': event.record.recordOwner + "-" + event.record.recordId, 'sectionId': 'PRHLC'}, this.frameRequestData('otherHealthInsuranceSummary', event.record.recordId)).subscribe(() => {    this.otherHealthInsuranceSummaryResults.splice(index, 1);
            this.otherHealthInsuranceSummaryResults = remainingRows;
            if(this.otherHealthInsuranceSummaryResults.length == 0){
              this.showOtherHealthInsurance = false;
            }
            else {
              this.showOtherHealthInsurance = true;
            }
            })
          }
        });
      }
    });
  }

  selfEmploymentRowEdit() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRIND');
  }

  selfEmploymentRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.selfEmploymentIncomeSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.selfEmploymentIncomeSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), {'individualId': event.record.individualId + "-" + event.record.recordId, 'sectionId': 'PRASM'}, this.frameRequestData('selfEmploymentSummary', event.record.recordId)).subscribe(() => {
              this.selfEmploymentIncomeSummaryResults.splice(index, 1);
              this.selfEmploymentIncomeSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  otherIncomeRowEdit() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRIND');
  }

  otherIncomeRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.otherIncomeSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.otherIncomeSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'),{'individualId': event.record.individualId+"-"+event.record.recordId,'sectionId': 'PRASM'}, this.frameRequestData('otherIncomeSummary', event.record.recordId)).subscribe(() => {
              this.otherIncomeSummaryResults.splice(index, 1);
              this.otherIncomeSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  taxDeductionsRowEdit() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRIND');
  }

  taxDeductionsRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.taxDeductionsSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.taxDeductionsSummaryResults.filter(row => row.taxDedSeqNum != event.record.taxDedSeqNum);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.indvId.toString() + "-" + event.record.taxDedSeqNum, 'sectionId': 'PRASM'}, this.frameRequestData('taxDeductionsSummary', event.record.taxDedSeqNum)).subscribe(() => {
              this.taxDeductionsSummaryResults.splice(index, 1);
              this.taxDeductionsSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  addIncomeDetails() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/PRIND');
  }
  
  otherQuestionRowEdit() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/AIBAO');
  }

  addOtherQuestionDetails() {
    this.router.navigateByUrl('/application/' + this.applicationNumber + '/section/AIBAO');
  }

  otherQuestionRowDelete(event: any) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.otherQuestionsSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'),{'individualId': event.record.identifier+"-6",'sectionId': 'PRASM'},  this.frameRequestData('otherQuestionSummary', event.record.identifier)).subscribe(() => {
              this.otherQuestionsSummaryResults.splice(index, 1);
            })
          }
        });
      }
    }); 
  }
  onTransferredResourcesRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.transferredResourcesSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.transferredResourcesSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'ASCLD'}, this.frameRequestData('transferSummary', event.record.recordId)).subscribe(() => {
              this.transferredResourcesSummaryResults.splice(index, 1);
              this.transferredResourcesSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  shelterOrUtilityExpenseRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.shelterOrUtilityExpenseSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.shelterOrUtilityExpenseSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'XPUTL'}, this.frameRequestData('shelterUtilitySummary', event.record.recordId)).subscribe(() => {
              this.shelterOrUtilityExpenseSummaryResults.splice(index, 1);
              this.shelterOrUtilityExpenseSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  dependentCareRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.dependentCareSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.dependentCareSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'XPDEP'}, this.frameRequestData('dependentCareSummary', event.record.recordId)).subscribe(() => {
              this.dependentCareSummaryResults.splice(index, 1);
              this.dependentCareSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onMandatoryPaymentsRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.mandatoryPaymentsSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.mandatoryPaymentsSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'XPSUP'}, this.frameRequestData('supportPaymentsSummary', event.record.recordId)).subscribe(() => {
              this.mandatoryPaymentsSummaryResults.splice(index, 1);
              this.mandatoryPaymentsSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onMedicalBillsRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.medicalBillsSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.medicalBillsSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'INMED'}, this.frameRequestData('medicareSummary', event.record.recordId)).subscribe(() => {
              this.medicalBillsSummaryResults.splice(index, 1);
              this.medicalBillsSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onAccessToOtherCoverageRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.accessToOtherCoverageSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.accessToOtherCoverageSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'XPOTH'}, this.frameRequestData('accessToOtherCoverageSummary', event.record.recordId)).subscribe(() => {
              this.accessToOtherCoverageSummaryResults.splice(index, 1);
              this.accessToOtherCoverageSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onFinancialResourcesRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.financialResourcesSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.financialResourcesSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'ASLIQ'}, this.frameRequestData('liquidResourceSummary', event.record.recordId)).subscribe(() => {
              this.financialResourcesSummaryResults.splice(index, 1);
              this.financialResourcesSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onVehicleRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.vehicleSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.vehicleSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'ASVEH'}, this.frameRequestData('vehicleResourceSummary', event.record.recordId)).subscribe(() => {
              this.vehicleSummaryResults.splice(index, 1);
              this.vehicleSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  onPropertyRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.propertySummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.propertySummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'ASPRP'}, this.frameRequestData('realEstateResourceSummary', event.record.recordId)).subscribe(() => {
              this.propertySummaryResults.splice(index, 1);
              this.propertySummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onBurialResourcesRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.burialResourcesSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.burialResourcesSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'ASBUR'}, this.frameRequestData('burialResourceSummary', event.record.recordId)).subscribe(() => {
              this.burialResourcesSummaryResults.splice(index, 1);
              this.burialResourcesSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onLifeInsuranceRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.lifeInsuranceSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.lifeInsuranceSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'ASLIF'}, this.frameRequestData('lifeInsuranceResourceSummary', event.record.recordId)).subscribe(() => {
              this.lifeInsuranceSummaryResults.splice(index, 1);
              this.lifeInsuranceSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }
  onOtherResourcesRowDelete(event: any) {
    if (!event?.record) return;
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.otherResourcesSummaryResults.forEach((item, index) => {
          if (equals(item, event.record)) {
            const remainingRows = this.otherResourcesSummaryResults.filter(row => row.recordId != event.record.recordId);
            this.appService.removeRecordPresumptive(sessionStorage.getItem('appNum'), { 'individualId': event.record.individualId.toString() + "-" + event.record.recordId, 'sectionId': 'OTHRS'}, this.frameRequestData('otherResourceSummary', event.record.recordId)).subscribe(() => {
              this.otherResourcesSummaryResults.splice(index, 1);
              this.otherResourcesSummaryResults = remainingRows;
            })
          }
        });
      }
    });
  }

  frameRequestData(keyArray, recordId) {
   const tempObj = {};
   Object.keys(this.record.data).forEach((x) => {
     tempObj[x] = [null];
   })
   delete tempObj[keyArray];
   delete tempObj['relationShipSummary'];
   delete tempObj['otherQuestionSummary'];
   tempObj['relationShipSummary'] = {'relationshipList': [null]};
   if (keyArray == 'otherQuestionSummary') {
      const otherQues = this.record.data.otherQuestionSummary.otherBenefitsIndvProfileData.filter(x => x.indvId == recordId);
      tempObj[keyArray] = {'otherBenefitsIndvProfileData': otherQues}
   } else if (keyArray === 'taxFilingSummary') {
      const taxRecord = this.record.data.taxFilingSummary.filter(x => x.taxFilingIndividualId == recordId);
      tempObj[keyArray] = taxRecord;
   } else if (keyArray === 'taxDeductionsSummary') {
      const taxRecord = this.record.data.taxDeductionsSummary.filter(x => x.taxDedSeqNum == recordId);
      tempObj[keyArray] = taxRecord;
   } else {
      tempObj['otherQuestionSummary'] = {'otherBenefitsIndvProfileData': [null]}
      tempObj[keyArray] = this.record.data[keyArray].filter(x => x.recordId == recordId);
   } 

   return tempObj;
  }

}